/**
 * useLatestAgentVersion
 *
 * Devuelve la última versión estable del agente publicada en el manifest
 * (mismo endpoint que usa el AgentDetail para chequear actualizaciones).
 * Devuelve `undefined` mientras el manifest está cargando o si falló.
 */
import { useQuery } from '@tanstack/react-query';
import apiClient from '@/api/client';

interface UpdateManifestLite {
  version: string;
  assets?: Array<{ os: string; arch: string }>;
}

export function useLatestAgentVersion(): string | undefined {
  const { data } = useQuery<UpdateManifestLite>({
    queryKey: ['agent-update-manifest', 'portable'],
    queryFn: async () => {
      const res = await apiClient.get<UpdateManifestLite>(
        '/agent-update?channel=stable&portable=true'
      );
      return res.data;
    },
    // El manifiesto se arma en vivo desde GitHub: tolerar fallas puntuales.
    retry: 2,
    retryDelay: 1500,
    staleTime: 30_000,
    refetchOnWindowFocus: true,
  });
  return data?.version;
}
